export default __webpack_public_path__ + "2c7b106406a2ea2f44231918e6a4ce12.svg";